import { render, staticRenderFns } from "./AppStoreBadges.vue?vue&type=template&id=a2cbe158&scoped=true"
import script from "./AppStoreBadges.vue?vue&type=script&lang=js"
export * from "./AppStoreBadges.vue?vue&type=script&lang=js"
import style0 from "./AppStoreBadges.vue?vue&type=style&index=0&id=a2cbe158&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cbe158",
  null
  
)

export default component.exports